import { useState } from "react";

export default function Logos() {
  const [paused, setPaused] = useState(false);

  const logos = [
    "https://optim.tildacdn.net/tild3733-3432-4364-b033-643665646161/-/cover/300x72/center/center/-/format/webp/sapiens.png.webp",
    "https://optim.tildacdn.net/tild6338-3330-4530-b964-386330356564/-/cover/218x72/center/center/-/format/webp/mislaka.png.webp",
    "https://optim.tildacdn.net/tild3931-3237-4163-b834-303230316265/-/cover/247x72/center/center/-/format/webp/gimmonix.png.webp",
    "https://optim.tildacdn.net/tild6234-6262-4937-b066-366364346264/-/cover/295x72/center/center/-/format/webp/fair-content.png.webp",
    "https://optim.tildacdn.net/tild6334-3534-4033-b835-626262613363/-/cover/301x72/center/center/-/format/webp/epam.png.webp",
  ];

  return (
    <div className="overflow-hidden border-y py-12 sm:py-20 w-full">
      <div
        className={`flex items-center gap-12 sm:gap-20 w-max animate-marquee ${
          paused ? "paused" : ""
        }`}
      >
        {[...logos, ...logos].map((logo, i) => (
          <img
            key={i}
            src={logo}
            onClick={() => setPaused((p) => !p)}
            className="h-10 sm:h-14 lg:h-16 w-auto object-contain flex-shrink-0 cursor-pointer"
          />
        ))}
      </div>
    </div>
  );
}